module.exports = __webpack_public_path__ + "img/loading.e3eacd85.gif";